export default "__VITE_ASSET__Cs$Evttc__"